import { DateTime } from "luxon";

export function getLastWeekDateRange() {
  const now = DateTime.now();
  const start = now.minus({ days: 7 });
  const end = now;

  return { start, end };
}
